import React, { useEffect, useState } from 'react'
import axios from 'axios'
import PageHeader from '../../shared/page-header/PageHeader'
import SKAlerts, { CreateAlert } from '../../shared/common-alerts/SKAlerts'
import { getApiBaseUrl } from '../../utils/apiConfig'
import { getModulePermissions } from '../../utils/permissionHelper'
import { exportToExcel, exportToPDF } from '../../utils/downloadExportedFiles'
import { logAuditEvent } from '../../utils/auditLogger'
import { getStorageValues } from '../../shared/CommonFunctions'
import HandoverRegisterGrid from './HandoverRegisterGrid'

function HandoverRegisterMain(props) {
  const [handoverRegisters, setHandoverRegisters] = useState([])
  const [alert, setAlert] = useState(null)
  const [userPermissions, setUserPermissions] = useState([])
  const moduleName = props.Module || 'Handover Register'

  useEffect(() => {
    const modulePermissions = getModulePermissions(props.Module)
    setUserPermissions(modulePermissions || [])
    fetchHandoverRegisters()
  }, [props.Module])

  useEffect(() => {
    logAuditEvent(moduleName, 'Accessed Module', `Accessed ${moduleName}`)
  }, [moduleName])

  const fetchHandoverRegisters = async () => {
    try {
      const params = { UserId: getStorageValues('userId') }
      const response = await axios.get(getApiBaseUrl() + '/handoverregister/getall', { params })
      if (response.status === 200) {
        setHandoverRegisters(response.data.data || [])
      }
    } catch (error) {
      console.log(error)
      CreateAlert('Unable to load handover register records', 'Error', setAlert)
    }
  }

  const handleExportExcel = () => {
    const columns = [
      { name: 'Customer Sales#', selector: 'SalesNumber' },
      { name: 'Customer Name', selector: 'CustomerName' },
      { name: 'Payment Mode', selector: 'PaymentMode' },
      { name: 'Customer Mobile', selector: 'MobileNumber' },
      { name: 'Status', selector: 'Status' }
    ]
    exportToExcel('HandoverRegister', columns, handoverRegisters)
  }

  const handleExportPDF = () => {
    const columns = [
      { name: 'Customer Sales#', selector: 'SalesNumber' },
      { name: 'Customer Name', selector: 'CustomerName' },
      { name: 'Payment Mode', selector: 'PaymentMode' },
      { name: 'Customer Mobile', selector: 'MobileNumber' },
      { name: 'Status', selector: 'Status' }
    ]
    exportToPDF('HandoverRegister', columns, handoverRegisters)
  }

  return (
    <>
      <SKAlerts alert={alert} />
      <PageHeader
        displayModule={props.Module}
        onRefresh={fetchHandoverRegisters}
        showPDF={true}
        showExcel={true}
        showPrint={false}
        showRefresh={true}
        onExcelExport={handleExportExcel}
        onPdfExport={handleExportPDF}
        showAddButton={false}
      />
      <HandoverRegisterGrid
        HandoverRegisterData={handoverRegisters}
        fetchHandoverRegisters={fetchHandoverRegisters}
        UserPermissions={userPermissions}
        moduleName={moduleName}
      />
    </>
  )
}

export default HandoverRegisterMain
